import React from 'react'

interface VideoEmbedDTProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const VideoEmbedDT: React.FC<VideoEmbedDTProps> = ({
  size = 20,
  color = '#003366',
  className,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path d="M18.3337 10.0013C18.3337 11.093 18.1253 12.1429 17.7337 13.1013C17.192 12.7263 16.5337 12.5013 15.8337 12.5013C15.0503 12.5013 14.3253 12.7763 13.7503 13.2346C12.9837 13.843 12.5003 14.7846 12.5003 15.8346C12.5003 16.4596 12.6753 17.0513 12.9836 17.5513C13.017 17.6096 13.0587 17.668 13.1087 17.7263C12.1503 18.118 11.1003 18.3346 10.0003 18.3346C5.40033 18.3346 1.66699 14.6013 1.66699 10.0013C1.66699 5.4013 5.40033 1.66797 10.0003 1.66797C14.6003 1.66797 18.3337 5.4013 18.3337 10.0013Z" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.81738 9.99999V8.84165C7.81738 7.40831 8.83404 6.81664 10.0757 7.53331L11.0757 8.10831L12.0757 8.68331C13.3174 9.39998 13.3174 10.575 12.0757 11.2917L11.0757 11.8667L10.0757 12.4417C8.83404 13.1583 7.81738 12.575 7.81738 11.1333V9.99999Z" stroke={color} strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M19.1667 15.8333C19.1667 16.4583 18.9917 17.05 18.6833 17.55C18.5083 17.85 18.2833 18.1167 18.025 18.3333C17.4417 18.8583 16.675 19.1667 15.8333 19.1667C14.6167 19.1667 13.5583 18.5167 12.9833 17.55C12.675 17.05 12.5 16.4583 12.5 15.8333C12.5 14.7833 12.9833 13.8417 13.75 13.2333C14.325 12.775 15.05 12.5 15.8333 12.5C17.675 12.5 19.1667 13.9917 19.1667 15.8333Z" stroke={color} strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M17.0751 15.8164H14.5918" stroke={color} strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M15.834 14.5996V17.0913" stroke={color} strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export default VideoEmbedDT
